<template>
  <div class="dropdown d-inline ">
    <soft-button v-show="statusSelected == ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class="dropdown-toggle ms-2"
      data-bs-toggle="dropdown" aria-expanded="true">{{ $t('key_filter_status') }}</soft-button>
    <soft-button v-show="statusSelected != ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class='dropdown-toggle ms-2 active-filter' 
      data-bs-toggle="dropdown" aria-expanded="false">{{ $t('key_filter_status') }}</soft-button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="navbarDropdownMenuLink2">
      <li>
        <button class="dropdown-item border-radius-md text-pending" :class="[statusSelected=='PENDIENTE'? 'active':'']" type="button" @click="handleClick('PENDIENTE')">{{ $t('key_pod_status_pending') }}</button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-delivered" :class="[statusSelected=='ENTREGADO'? 'active':'']" type="button" @click="handleClick('ENTREGADO')">{{ $t('key_pod_status_delivered') }}</button>
      </li>
      <li>
        <hr class="horizontal my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">{{ $t('key_filters_clear_filters') }}</button>
      </li>
    </ul>   
  </div>
</template>

<script>

  import SoftButton from "@/components/SoftButton.vue";  

  export default {
    name:"ShipmentsFilter",
    components: {
      SoftButton,  
    },
    props: {
      filterStatusSelected: {
        type: String,
        default: () => '',
      },
    },
    emits: ['filter-change'],
    data() {
      return {
        statusSelected:""
      }
    },
    computed: {
      listFilters() {
        return this.$store.state.manifiest.listFilters;
      },
    },
    watch: {
      filterStatusSelected() {
        this.statusSelected = this.filterStatusSelected
      }
    },
    mounted() {
      this.setUpFilters()
    },
    methods: {
      handleClick(status) {
        this.statusSelected=status
        this.$emit('filter-change',status)
      },
      setUpFilters() {
        if (Object.keys(this.listFilters).length > 0) {

          const { filters } = this.listFilters

          if (filters['status']) {
            this.statusSelected = filters['status']
          }
        }
      },
    },
  }

</script>

<style scoped>

  .active{
    background-color: rgb(234, 244, 247) !important;
  }

  .active-filter {
    color: #fff;
    background-color: #42695c;
    border-color: #42695c;
  }

</style>